import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { routes } from "./found-medication-incident.routing";

@NgModule({
	imports: [RouterModule.forChild(routes)],
	declarations: [],
})
export class FoundMedicationIncidentModule {}
